import { useCallback } from 'react'

import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useModalData } from '../../../hooks/useModalData'
import { useTexts } from '../../../useTexts'

import { useButtonClassName } from './hooks/useButtonClassName'

export function ButtonMove() {
  const ctrl = useController()
  const { move } = useControllerActions()
  const data = useModalData()
  const texts = useTexts()

  const { type, suffix } = useButtonClassName(data)

  const handleOnClick = useCallback(() => {
    move(true)
  }, [move])

  const { isExecuted, gotExecutedPaired, payload } = data

  const className = `pendo-moving-${type}_move-${type}${suffix}`
  const testid = `moving-${type}_move-${type}${suffix}`
  const color = isExecuted || gotExecutedPaired || !payload.paired ? 'error' : 'primary'

  return (
    <ModalFooterButton
      className={className}
      disabled={ctrl.status === 'pending'}
      onClick={handleOnClick}
      variant="contained"
      testid={testid}
      color={color}
    >
      {data.payload.paired
        ? texts.btnMovePaired(data.orderStep.type, data.pairedOrderStepUnassigned)
        : texts.btnMoveSingle}
    </ModalFooterButton>
  )
}
